import _ from 'lodash';

export function isNullOperator({ observation, children }) {
  let [parameterObject] = children;

  let { parameter } = parameterObject.content;
  let observationValue = observation.values[parameter];

  return _.isNull(observationValue)
}